import { styled } from '@mui/material'
import { useLocation } from '@reach/router'
import { Box } from '@mui/system'
import React, { FC, PropsWithChildren } from 'react'
import { colors } from '../../constants/colors'
import { pageState } from '../../context/page-context'
import { VBox } from '../../elements/basic-elements'

const Page: FC<PropsWithChildren<{ Header?: React.FC }>> = ({ children, Header }) => {
  const { pageRef, pageContentRef } = pageState()
  const location = useLocation()
  const normalizedPath = (location?.pathname || '').replace(/\/+$/, '') || '/'
  const isAplPage =
    normalizedPath === '/actually-pro-life' ||
    normalizedPath.startsWith('/actually-pro-life/positions/')
  const useDocumentScroll = isAplPage
  const hideGlobalHeader = normalizedPath === '/actually-pro-life'

  return (
    <PageContainer ref={pageRef}>
      {Header && !hideGlobalHeader && (
        <HeaderContainer>
          <Header />
        </HeaderContainer>
      )}
      <PageContentContainer $useDocumentScroll={useDocumentScroll}>
        <PageContent ref={pageContentRef}>{children}</PageContent>
      </PageContentContainer>
    </PageContainer>
  )
}

const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100svh;
  background: ${colors.GLACIER_BLUE_70};

  @media (prefers-color-scheme: dark) {
    background: ${colors.DARK_MODE_100};
  }

  * {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
const HeaderContainer = styled(Box)`
  position: relative;
  z-index: 1;
`

const PageContentContainer = styled(VBox, {
  shouldForwardProp: prop => prop !== '$useDocumentScroll'
})<{ $useDocumentScroll?: boolean }>`
  position: relative;
  z-index: 0;
  flex: 1;
  padding: 0;
  overflow-y: ${({ $useDocumentScroll }) => ($useDocumentScroll ? 'visible' : 'auto')};
  overflow-x: visible;
`
const PageContent = styled(VBox)`
  min-height: 100%;
  flex: 1;
`

export default Page
